// extracted by mini-css-extract-plugin
export var callCard = "_rz-0";
export var callMessageButton = "_rz-1";
export var helpIcon = "_rz-3";
export var helpIconContainer = "_rz-4";
export var verticalDivider = "_rz-2";